(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-hero')) {
    customElements.define('cb-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-cb-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-cb-dot]'));
        this.current = 0;
        this.timer = null;
        this.userPaused = false;
        this.toggle = this.querySelector('[data-cb-toggle]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.dots.forEach((dot) => dot.addEventListener('click', () => {
          this.show(Number(dot.dataset.cbDot));
          this.restart();
        }));
        this.toggle?.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.renderToggle();
          if (this.userPaused) this.stop();
          else this.start();
        });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', this.handleVisibility);
        this.reducedMotion.addEventListener('change', this.handleMotionChange);
        this.renderToggle();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.handleVisibility);
        this.reducedMotion.removeEventListener('change', this.handleMotionChange);
      }

      handleVisibility = () => {
        if (document.hidden) this.stop();
        else this.start();
      };

      handleMotionChange = () => {
        if (this.reducedMotion.matches) this.stop();
        else this.start();
        this.renderToggle();
      };

      renderToggle() {
        if (!this.toggle) return;
        if (this.reducedMotion.matches) {
          this.toggle.disabled = true;
          this.toggle.setAttribute('aria-label', '自動切り替えは端末設定により停止中');
          this.toggle.querySelector('span').textContent = '▶';
          return;
        }
        this.toggle.disabled = false;
        this.toggle.setAttribute('aria-label', this.userPaused ? '自動切り替えを再開' : '自動切り替えを一時停止');
        this.toggle.querySelector('span').textContent = this.userPaused ? '▶' : 'Ⅱ';
      }

      show(index) {
        if (!this.slides.length) return;
        this.current = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
      }

      start() {
        if (this.userPaused || this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.reducedMotion.matches || document.hidden || this.timer) return;
        const interval = Math.max(Number(this.dataset.interval) || 6000, 3000);
        this.timer = window.setInterval(() => this.show(this.current + 1), interval);
      }

      stop() {
        if (!this.timer) return;
        window.clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
